import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  copyIcon: {
    '&&': {
      color: theme.palette.custom.grey2,
      width: 20,
      height: 20,
    },
  },
  iconsWrapper: {
    display: 'flex',
    gap: '3px',
  },
  modalWrapper: {
    minHeight: 360,
    [theme.breakpoints.down('tablet')]: {
      minWidth: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: `${SPACES.xxl} 0`,
  },
}))

export { useStyles }
